/* ── Studio Phalsa — Collection Page JS ─────────────────────── */
(function () {
  'use strict';

  // drawer code

  /* ── Filter drawer ─────────────────────────────────────── */

  var filterOpen = document.getElementById('sp-filter-open');
  var filterClose = document.getElementById('sp-filter-close');
  var filterPanel = document.querySelector('.sp-filter-panel');
  var filterOverlay = document.getElementById('sp-filter-overlay');

  function openFilterDrawer() {
    if (!filterPanel || !filterOverlay) return;

    filterPanel.classList.add('is-active');
    filterOverlay.classList.add('is-active');
    document.body.classList.add('sp-filter-lock');

    if (filterOpen) {
      filterOpen.setAttribute('aria-expanded', 'true');
    }
  }

  function closeFilterDrawer() {
    if (!filterPanel || !filterOverlay) return;

    filterPanel.classList.remove('is-active');
    filterOverlay.classList.remove('is-active');
    document.body.classList.remove('sp-filter-lock');

    if (filterOpen) {
      filterOpen.setAttribute('aria-expanded', 'false');
    }
  }

  if (filterOpen) {
    filterOpen.addEventListener('click', openFilterDrawer);
  }

  if (filterClose) {
    filterClose.addEventListener('click', closeFilterDrawer);
  }

  if (filterOverlay) {
    filterOverlay.addEventListener('click', closeFilterDrawer);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeFilterDrawer();
    }
  });


  /* ── Scroll reveal: fade-up cards as they enter viewport ─────── */
  var cards = document.querySelectorAll('.sp-col-card');
  if (!cards.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  cards.forEach(function (card) { io.observe(card); });

  /* ── Wishlist toggle ─────────────────────────────────────────── */
  document.querySelectorAll('.sp-col-card__wishlist').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isLiked = btn.classList.toggle('is-liked');
      btn.setAttribute('aria-label', isLiked
        ? 'Remove from wishlist'
        : 'Add to wishlist'
      );
    });
  });

  /* ── Add to cart ─────────────────────────────────────────────── */
  document.querySelectorAll('.sp-col-card__add-btn').forEach(function (btn) {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }]
          })
        });

        var data = await response.json();
        console.log('[SP] Cart add response:', data);

        if (!response.ok || data.status) {
          console.error('[SP] Cart add failed:', data);
          return;
        }

        /* Fetch updated cart for badge count + Horizon event payload */
        var cart = await fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        }).then(function (r) { return r.json(); });

        /* Update navbar cart badge */
        var badge = document.querySelector('.sp-navbar__cart-badge');
        if (badge) badge.textContent = cart.item_count;

        /* Dispatch Horizon's cart:update event — triggers cart drawer */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            data: { itemCount: cart.item_count }
          }
        }));

        /* Fallback: click cart button or call open() directly */
        var cartBtn = document.querySelector('.sp-navbar__cart-btn');
        if (cartBtn) {
          cartBtn.click();
        } else {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }

      } catch (err) {
        console.error('[SP] Add to cart error:', err);
      }
    });
  });

  var sortSelect = document.querySelector('#SPCollectionSort');

var sortSelect = document.querySelector('#SPCollectionSort');

if (sortSelect) {
  sortSelect.addEventListener('change', function () {
    var selectedSort = this.value;
    var currentUrl = new URL(window.location.href);

    if (selectedSort === '') {
      currentUrl.searchParams.delete('sort_by');
    } else {
      currentUrl.searchParams.set('sort_by', selectedSort);
    }

    window.location.href = currentUrl.toString();
  });
}

})();
